import { render, staticRenderFns } from "./McRedpack.vue?vue&type=template&id=22dedaac&scoped=true&"
import script from "./McRedpack.vue?vue&type=script&lang=js&"
export * from "./McRedpack.vue?vue&type=script&lang=js&"
import style0 from "./McRedpack.vue?vue&type=style&index=0&id=22dedaac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dedaac",
  null
  
)

export default component.exports